<template>
  <div class="total-resource-info q-pa-md">
    Total:
    <span class="text-weight-bold"> {{ devicesInfo }} GPU devices x {{ memoryInfo }} x {{ workersInfo }} workers </span>
  </div>
</template>

<script lang="ts">
import type { IUISuperWorkloadSpec } from "@/models/workload.model";
import { GpuRequestType } from "@/swagger-models/assets-service-client";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "total-compute-resources-info",
  props: {
    distributedSpec: {
      type: Object as PropType<IUISuperWorkloadSpec>,
      required: true,
    },
  },
  computed: {
    devicesInfo(): string {
      return `${this.distributedSpec.compute?.gpuDevicesRequest || 0}`;
    },
    workersInfo(): string {
      return `${this.distributedSpec.numWorkers}`;
    },
    memoryInfo(): string {
      switch (this.distributedSpec.compute?.gpuRequestType) {
        case GpuRequestType.Memory:
          return `${this.distributedSpec.compute?.gpuMemoryRequest}B`;
        case GpuRequestType.Portion:
          return `${((this.distributedSpec.compute?.gpuPortionRequest || 0) * 100).toFixed(0)}%`;
        case GpuRequestType.MigProfile:
          return `${this.distributedSpec.compute?.migProfile}`;
        default:
          return "0";
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.total-resource-info {
  color: $black-54;
  border: 1px $black-12 solid;
}
</style>
